import React, { useEffect, useState } from "react";
//outsource
import { Row, Col, Space, Typography } from "antd";
import moment from "moment";
//components
import DialogWeekFrom from "./dialog_week_from";
import DialogWeekTo from "./dialog_week_to";
import DialogSelectBranch from "./dialog_select_branch";
import DialogOff from "./dialog_off";

//redux
import { useSelector } from "react-redux";
import { branchsSelector } from "../../../../store/branch/branch.selector";

const { Text } = Typography;
const CardWeek = ({ index, selected, date, data, setData }) => {
  // -------------------------- VAR --------------------------
  // console.log({ data });
  // -------------------------- STATE --------------------------
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [branch, setBranch] = useState("");
  const [off, setOff] = useState(false);
  const [user, setUser] = useState("");
  const [roster, setRoster] = useState(null);
  // console.log({ user });
  // -------------------------- REDUX --------------------------
  const branchs = useSelector(branchsSelector);
  // -------------------------- FUNCTION --------------------------
  const handleChange = (id, value) => {
    let obj = {};
    let isaction = roster === null ? true : false;

    // check is already date
    const diff =
      data?.length > 0
        ? data?.filter((item) => item?.date === date)?.length === 0
        : [];

    //create;
    if (diff || diff?.length === 0) {
      obj = {
        ...obj,
        // workAt: moment(date, "ddd DD MMM YYYY").startOf("day")?._d,
        // endAt: moment(date, "ddd DD MMM YYYY").endOf("day")?._d,
        workAt: from ? from?._d : moment(date, "ddd DD MMM YYYY").startOf("day")?._d,
        endAt: to ? to?._d : moment(date, "ddd DD MMM YYYY").endOf("day")?._d,
        branch,
        off: false,
        staff: user,
      };

      const newObj = assignValueObject({ id, value, obj, isaction });

      setData((data) => [...data, newObj]);
    } else {
      const newObj = assignValueObject({ id, value, obj, isaction });
      console.log({ newObj: newObj });
      const replace = data?.map((item) =>
        item?.date === date ? { ...item, ...newObj } : item
      );

      setData(replace);
    }
  };

  const assignValueObject = ({ id, value, obj, isaction }) => {
    // assign date
    obj = { ...obj, date };

    // console.log("set up action...");
    if (isaction) {
      const action = "create";
      obj = { ...obj, action };
    } else {
      const action = "update";
      const rosterId = roster?.id;
      obj = { ...obj, action, roster: rosterId };
    }

    //convert timestring
    // console.log("assign time string...");
    if (id === "workAt" || id === "endAt") {
      const timeString = value?.format("hh:mm A");
      const time = moment(
        `${date} ${timeString}`,
        "ddd DD MMM YYYY hh:mm A"
      )?._d;

      obj = { ...obj, [id]: time };
    } else {
      obj = { ...obj, [id]: value };
    }

    return obj;
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (selected) {
      console.log({ selected });
      const rosters = selected?.rosters || null;
      const user = selected?.user || "";
      const branch = selected?.branch || "";
      let branchs = selected?.branchs || [];
      branchs = branchs?.filter((b) => {
        const staffs = b?.staffs || [];
        const valids = staffs?.includes(user) || false;
        return valids;
      });

      const roster =
        (rosters &&
          rosters.find((item) => item.staff === user && item.date === date)) ||
        null;

      //branch
      const branchId = roster?.branch ? roster?.branch : branch || "";

      const off = roster && roster?.off;

      const workAt = roster && roster.workAt;
      const wSeconds = workAt && workAt.seconds;
      const from = wSeconds && moment(workAt.toDate());
      // End At
      const endAt = roster && roster.endAt;
      const eSeconds = endAt && endAt.seconds;
      const to = eSeconds && moment(endAt.toDate());

      const disabled = data?.find((item) => item?.date === date)?.off || false;
      const block = off !== null ? off : disabled;

      setFrom(from);
      setTo(to);
      setOff(block);
      setBranch(branchId);
      setUser(user);
      setRoster(roster);
      console.log("setState")
    }
  }, [selected]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row key={index} gutter={[10, 10]} className="card-week" align="middle">
      <Col span={24}>
        <Text strong style={{ color: off ? "gray" : "#1976d2" }}>
          {date}
        </Text>
      </Col>
      <Col span={6}>
        <DialogWeekFrom
          to={to}
          from={from}
          disabled={off}
          onChange={handleChange}
          setFrom={setFrom}
        />
      </Col>
      <Col span={6}>
        <DialogWeekTo
          from={from}
          to={to}
          disabled={off}
          setTo={setTo}
          onChange={handleChange}
        />
      </Col>
      <Col span={8}>
        <DialogSelectBranch
          branch={branch}
          branchs={branchs}
          setBranch={setBranch}
          disabled={off}
          onChange={handleChange}
        />
      </Col>
      <Col span={4} align="right">
        <DialogOff off={off} setOff={setOff} onChange={handleChange} />
      </Col>
    </Row>
  );
};

export default CardWeek;
